export const MIN_CARDS_TO_SELECT = 2;
